// extracted by css-extract-rspack-plugin
export default {"checkboxLabelTooltips":"Vbq2jnXl0_xU8VK1"};